exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-container{font-family:dnp-shuei-mgothic-std,sans-serif;max-width:580px;margin:0 auto;background:#fff;min-height:100vh;padding-top:64px}.app_logoutimg{width:0;height:0;display:block}.main-contents{width:100%;min-height:100%}.loading-font{visibility:hidden}.loading-delay,.wf-active{visibility:visible}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-aaa34c2e","scoped":false,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/utvStore/components/AppContainerChoun.vue
// module id = I8jJ
// module chunks = 0